export const COOKIE_ACCESS_ROLE = "__FANAM_YDFDCDF__";
export const COOKIE_ACCESS_MAIL = "__FANAMA_DHDFMD__";
export const COOKIE_ACCESS_BOARD = "__FANAMA_LKJMNH__";
export const COOKIE_ACCESS_EXAM = "__FANAMA_NWJWWN__";
export const COOKIE_ACCESS_MEDIUM = "__FANAMA_DNJDMSJ__";
export const COOKIE_ACCESS_SESSION = "__FANAMA_DNHDHWME__";
export const COOKIE_ACCESS_SESSION_EXPIRY = "__FANAMA_KDNNDBA__";
export const COOKIE_ACCESS_SUBSCRIPTION_STATUS = "__FANAMA_BUEWOPQW__";
export const COOKIE_ACCESS_SECTION = "__FANAMA_SNHDMQNN__";
export const COOKIE_ACCESS_SUBSCRIBED_COURSES = "__FANAMA_SMNNANABS__";
